import script from "./fclty-adit-info-chng.vue?vue&type=script&setup=true&lang=js"
export * from "./fclty-adit-info-chng.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__